/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseDelReqVo
 */
export interface WarehouseDelReqVo {
    /**
     * 仓库ID列表
     * @type {Array<number>}
     * @memberof WarehouseDelReqVo
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the WarehouseDelReqVo interface.
 */
export function instanceOfWarehouseDelReqVo(value: object): value is WarehouseDelReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function WarehouseDelReqVoFromJSON(json: any): WarehouseDelReqVo {
    return WarehouseDelReqVoFromJSONTyped(json, false);
}

export function WarehouseDelReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseDelReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function WarehouseDelReqVoToJSON(json: any): WarehouseDelReqVo {
    return WarehouseDelReqVoToJSONTyped(json, false);
}

export function WarehouseDelReqVoToJSONTyped(value?: WarehouseDelReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

